import { render, staticRenderFns } from "./ForbiddenKeywordsFilter.vue?vue&type=template&id=608ccfc7&scoped=true"
import script from "./ForbiddenKeywordsFilter.vue?vue&type=script&lang=js"
export * from "./ForbiddenKeywordsFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608ccfc7",
  null
  
)

export default component.exports